import React, { useCallback, useEffect } from "react";
import logo from "../../Assets/img/PC-logo.png";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Store";

export default function NewHeader() {
   const { pathname } = useLocation();
   const { isAuth } = useSelector((state: RootState) => state.auth);

   useEffect(() => {
      window.$(window).scroll(function () {
         if (window.$(this).scrollTop() > 100) {
            window.$("#header").addClass("header-scrolled");
         } else {
            window.$("#header").removeClass("header-scrolled");
         }
      });

      window.$(".nav-menu").superfish({
         animation: {
            opacity: "show",
         },
         speed: 400,
      });

      if (window.$("#nav-menu-container").length) {
         window
            .$("#mobile-nav")
            .find(".menu-has-children")
            .prepend('<i className="lnr lnr-chevron-down"></i>');

         window.$(document).on("click", ".menu-has-children i", function (e) {
            console.log("clicked-2");
            window.$(this).next().toggleClass("menu-item-active");
            window.$(this).nextAll("ul").eq(0).slideToggle();
            window.$(this).toggleClass("lnr-chevron-up lnr-chevron-down");
         });

         window
            .$(document)
            .not("#mobile-nav-toggle")
            .click(function (e) {
               var container = window.$("#mobile-nav, #mobile-nav-toggle");
               if (!container.is(e.target) && container.has(e.target).length === 0) {
                  if (window.$("body").hasClass("mobile-nav-active")) {
                     window.$("body").removeClass("mobile-nav-active");
                     window
                        .$("#mobile-nav-toggle i")
                        .toggleClass("lnr-cross lnr-menu");
                     window.$("#mobile-body-overly").fadeOut();
                  }
               }
            });
      } else if (window.$("#mobile-nav, #mobile-nav-toggle").length) {
         window.$("#mobile-nav, #mobile-nav-toggle").hide();
      }
   }, []);

   const onMenuClick = useCallback(() => {
      window.$("body").toggleClass("mobile-nav-active");
      window.$("#mobile-nav-toggle i").toggleClass("lnr-cross lnr-menu");
      window.$("#mobile-body-overly").toggle();
   }, []);

   useEffect(() => {
      window.$("html, body").scrollTop(0);
      if (window.$("body").hasClass("mobile-nav-active")) {
         onMenuClick();
      }
   }, [pathname, onMenuClick]);

   return (
      <section className="w-full border-b bg-white shadow-sm">
         <div className="max-w-6xl mx-auto px-6 py-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
               {/* LOGO */}
               <div className="flex justify-center md:justify-start w-full md:w-auto">

                  <Link to="/">
                     <img src={logo} alt="Pride Circle" className="h-10" />
                  </Link>
               </div>
               {/* BUTTONS */}

               {pathname === "/" ? (
                  <div className="flex items-center gap-3 justify-center md:justify-end w-full md:w-auto">
                     <Link to="/job-seeker">
                        <button
                           className="px-6 py-2 rounded-xl bg-indigo-600 text-white font-medium transition"
                        >Job Seeker</button>
                     </Link>

                     <Link to="/employer">
                        <button className="px-6 py-2 rounded-xl border border-gray-300 text-gray-700 font-medium transition"
                        >Employer</button>
                     </Link>
                     {/* WHATSAPP */}
                     <Link
                        to="https://wa.me/919599681727"
                        target="_blank"
                        className="text-green-600 text-xl hover:scale-110 transition"
                     >
                        <i className="fab fa-whatsapp" />
                     </Link>
                     {/* EMAIL */}
                     <Link
                        to="mailto:rise@thepridecircle.com"
                        target="_blank"
                        className="text-indigo-600 text-xl hover:scale-110 transition"
                     >
                        <i className="fas fa-envelope" />
                     </Link>
                  </div>) : (<div className="flex items-center gap-4">
                     {pathname === "/employer" ? (<Link target="_blank"
                        to="https://recruiter.thepridecircle.com/login" className="px-5 py-2 bg-indigo-600 text-white rounded-xl">
                        Login
                     </Link>) : (<Link to="/login" className="px-5 py-2 bg-indigo-600 text-white rounded-xl">
                        Login
                     </Link>)}

                     {/* WHATSAPP */}
                     <Link
                        to="https://wa.me/919599681727"
                        target="_blank"
                        className="text-green-600 text-xl hover:scale-110 transition"
                     >
                        <i className="fab fa-whatsapp" />
                     </Link>
                     {/* EMAIL */}
                     <Link
                        to="mailto:rise@thepridecircle.com"
                        target="_blank"
                        className="text-indigo-600 text-xl hover:scale-110 transition"
                     >
                        <i className="fas fa-envelope" />
                     </Link></div>)}

            </div>
         </div>
      </section>
   );
}
